module.exports = __webpack_public_path__ + "static/media/image09.499f97bb.jpg";